import React from "react";

export default function ThankYou() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#0f172a,#1e293b)",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          width: "100%",
          background: "#1e293b",
          padding: "50px",
          borderRadius: "18px",
          textAlign: "center",
          boxShadow: "0 20px 50px rgba(0,0,0,.35)",
        }}
      >
        <div style={{ fontSize: "70px" }}>🎉</div>

        <h1
          style={{
            color: "#22c55e",
            fontSize: "42px",
            marginTop: "15px",
          }}
        >
          Payment Successful
        </h1>

        <p
          style={{
            fontSize: "22px",
            lineHeight: "1.8",
            marginTop: "20px",
          }}
        >
          Welcome to <b>Grads2Pro</b>
          <br />
          Your seat has been confirmed successfully.
        </p>

        <div
          style={{
            background: "#0f172a",
            padding: "25px",
            borderRadius: "12px",
            marginTop: "35px",
            textAlign: "left",
          }}
        >
          <h2 style={{ color: "#facc15" }}>Next Steps</h2>

          <p style={{ lineHeight: "2", marginTop: "15px" }}>
            ✅ Join the WhatsApp Community
            <br />
            ✅ Zoom Link will be shared there
            <br />
            ✅ Study Materials will be shared there
            <br />
            ✅ Important announcements will be posted there
          </p>
        </div>

        <a
          href="https://chat.whatsapp.com/G0Rs4Qw18CV8KfLAwZZ4Ub?mode=gi_t"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "40px",
            background: "#25D366",
            color: "#fff",
            padding: "22px 45px",
            fontSize: "24px",
            fontWeight: "bold",
            borderRadius: "12px",
            textDecoration: "none",
          }}
        >
          🟢 JOIN WHATSAPP COMMUNITY
        </a>

        <p
          style={{
            marginTop: "35px",
            color: "#94a3b8",
            lineHeight: "1.8",
          }}
        >
          Please join immediately.
          <br />
          Without joining the community, you may miss the Zoom meeting link and
          important announcements.
        </p>
      </div>
    </div>
  );
}
